<template>
    <analytics-widget
        title="Analytics Overview"
        description="Stats are available only for shows hosted with Fusebox"
    >
        <template v-slot="{ range, ready, showHash }">
            <div class="panel" :class="showHash && 'cols-2'">
                <top-listens
                    :from="range.from"
                    :limit="showHash ? 10 : 5"
                    :ready="ready"
                    :show-hash="showHash"
                    :to="range.to"
                    wait-until-ready
                />
            </div>
            <div v-if="!showHash" class="panel">
                <top-shows
                    :from="range.from"
                    :ready="ready"
                    :to="range.to"
                    wait-until-ready
                />
            </div>
        </template>
    </analytics-widget>
</template>

<script>
import * as components from '@/components/Analytics';
import AnalyticsWidget from '@/components/Analytics/Widget';

export default {
    components: {
        ...components,
        AnalyticsWidget,
    },
};
</script>
